import React from "react";
import { Box, Card, CardContent, Typography, Button } from "@mui/material";

const ViewEmployee: React.FC = () => {
  return (
    <Box
      sx={{
        height: "100vh",
        bgcolor: "#f5f5f5",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Card sx={{ minWidth: 300, padding: 2 }}>
        <CardContent>
          <Typography variant="h5" gutterBottom>
            Welcome to Sample Page
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            This is a simple page built with Material UI in React.
          </Typography>
          <Button variant="contained" color="primary" onClick={() => alert("Clicked!")}>
            Click Me
          </Button>
        </CardContent>
      </Card>
    </Box>
  );
};

export default ViewEmployee;